<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 9.375H16V7.25C16 4.90607 14.2061 3 12 3C9.79395 3 8 4.90607 8 7.25V9.375H7.5C6.67334 9.375 6 10.0896 6 10.9687V18.4062C6 19.2854 6.67334 20 7.5 20H16.5C17.3267 20 18 19.2854 18 18.4062V10.9687C18 10.0896 17.3267 9.375 16.5 9.375ZM9.33337 7.25C9.33337 5.68738 10.5293 4.41671 12 4.41671C13.4707 4.41671 14.6666 5.68738 14.6666 7.25V9.375H9.33337V7.25Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
</template>
